//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : code:		plustic — massimo cardascia — www.plustic.de
///h : code language:	php 5.6
///h : code style:	whitesmiths style variant - 8 spaces tab - http://en.wikipedia.org/wiki/indent_style
//////////////////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : paths
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

 
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : imports
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

///h : isinviewport - v.1.0 - https://github.com/zeusdeux/isInViewport - viewport detection
!function(a,b){function c(b){var c,d=a("<div></div>").css({width:"100%"});return b.append(d),c=b.width()-d.width(),d.remove(),c}function d(e,f){var g=e.getBoundingClientRect(),h=g.top,i=g.bottom,j=g.left,k=g.right,l=a.extend({tolerance:0,viewport:b},f),m=!1,n=l.viewport.jquery?l.viewport:a(l.viewport);n.length||(console.warn("isInViewport: The viewport selector you have provided matches no element on page."),console.warn("isInViewport: Defaulting to viewport as window"),n=a(b));var o=n.height(),p=n.width(),q=n[0].toString();if(n[0]!==b&&"[object Window]"!==q&&"[object DOMWindow]"!==q){var r=n[0].getBoundingClientRect();h-=r.top,i-=r.top,j-=r.left,k-=r.left,d.scrollBarWidth=d.scrollBarWidth||c(n),p-=d.scrollBarWidth}return l.tolerance=~~Math.round(parseFloat(l.tolerance)),l.tolerance<0&&(l.tolerance=o+l.tolerance),0>=k||j>=p?m:m=l.tolerance?h<=l.tolerance&&i>=l.tolerance:i>0&&o>=h}String.prototype.hasOwnProperty("trim")||(String.prototype.trim=function(){return this.replace(/^\s*(.*?)\s*$/,"$1")});var e=function(b){if(1===arguments.length&&"function"==typeof b&&(b=[b]),!(b instanceof Array))throw new SyntaxError("isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions");for(var c=0;c<b.length;c++)if("function"==typeof b[c])for(var d=0;d<this.length;d++)b[c].call(a(this[d]));else console.warn("isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions"),console.warn("isInViewport: Ignoring non-function values in array and moving on");return this};a.fn["do"]=function(a){return console.warn("isInViewport: .do is deprecated as it causes issues in IE and some browsers since it's a reserved word. Use $.fn.run instead i.e., $(el).run(fn)."),e(a)},a.fn.run=e;var f=function(b){if(b){var c=b.split(",");return 1===c.length&&isNaN(c[0])&&(c[1]=c[0],c[0]=void 0),{tolerance:c[0]?c[0].trim():void 0,viewport:c[1]?a(c[1].trim()):void 0}}return{}};a.extend(a.expr[":"],{"in-viewport":a.expr.createPseudo?a.expr.createPseudo(function(a){return function(b){return d(b,f(a))}}):function(a,b,c){return d(a,f(c[3]))}}),a.fn.isInViewport=function(a){return this.filter(function(b,c){return d(c,a)})}}(jQuery,window);


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : class definition
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

///h : class
function dc7__dom(){this.f_construct();}

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : class properites
	//////////////////////////////////////////////////////////////////////////////////////////////////////

	///h : class vars
	dc7__dom.__o_data = null;				///h : stores class data
	dc7__dom.__o_config = null;				///h : stores class config


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : class system init
	//////////////////////////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_initSystem = function()
		{
		dc7__dom.f_init();
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : class methods - default
	//////////////////////////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_init = function()
		{
		///: init config
		dc7__dom.f_initData();

		///: init config
		dc7__dom.f_initContent();
		}




	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init data
	/**
	 * init data
	 * used to init all data later on used in the class context like
	 * configuration arrays etc.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_initData = function()
		{
		///h :
		dc7__dom.__o_data = {};
		dc7__dom.__o_data['o_vars'] = {};
		dc7__dom.__o_data['i_domindex'] = -1;
		dc7__dom.__o_data['s_domtimestamp'] = Date.now().toString(36).substr(-6);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_initContent = function()
		{
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_setStorageData = function($jqo_dom, $storage_data)
		{
		///h :
		dc7__dom.f_getVar($jqo_dom, 'storage_data', $storage_data);
		}

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_getStorageData = function($jqo_dom, $s_id)
		{
		///h :
		var $storage_data = null;		///h :

		///h :
		$storage_data = dc7__dom.f_getVar($jqo_dom, 'storage_data');
		$s_id = dc7__var.f_initVar($s_id, null);

		///h : fist init
		if($storage_data === null)
			{
			///h :
			$storage_data = {};

			///h : merge dom data data attribute if present
			if($s_id !== null)
				{
				///h :
				$o_data = dc7__dom.f_getDataAttrObject($jqo_dom, $s_id);
				if($o_data !== null)
					{
					$storage_data = $o_data;
					}
				}

			///h : update
			$storage_data = dc7__dom.f_setVar($jqo_dom, 'storage_data', $storage_data);
			}

		///h : 
		return($storage_data);
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_getTagType = function($jqo_dom)
		{
		///h :
		return($jqo_dom.prop('tagName').toLowerCase());
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_getDataAttrObject = function($jqo_dom, $s_id)
		{
		///h :
		$o_data = null;		///h :
		$s_data = null;		///h :

		///h :
		$s_data = $jqo_dom.data($s_id);
		$o_data = dc7__string.f_getDataObject($s_data);

		///h :
		return($o_data);
		}
	

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_getVar = function($jqo_dom, $s_var_name)
		{
		///h : properties
		var $o_var_value = null;		///h :
		var $s_id = null;			///h :
		var $o_var_value = null;		///h :

		///h : get id
		$s_id = dc7__dom.f_getID($jqo_dom);

		///h : check if storage existing
		if(dc7__dom.__o_data['o_vars'][$s_id] !== undefined)
			{
			///h : get storage var
			$o_var_value = dc7__dom.__o_data['o_vars'][$s_id][$s_var_name];
			}

		///h : 
		$o_var_value = (($o_var_value === undefined) ? null : $o_var_value);

		///h : return
		return($o_var_value);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_setVar = function($jqo_dom, $s_var_name, $o_var_value)
		{
		///h : properties
		var $s_id = null;		///h :

		///h : get id
		$s_id = dc7__dom.f_getID($jqo_dom);

		///h :
		if(dc7__dom.__o_data['o_vars'][$s_id] === undefined)
			{
			dc7__dom.__o_data['o_vars'][$s_id] = {};
			}

		///h : set var
		dc7__dom.__o_data['o_vars'][$s_id][$s_var_name] = $o_var_value;
		
		///h : return
		return($o_var_value);
		}
		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_setRootClassVar = function($s_var_name, $o_var_value)
		{
		///h :
		dc7__dom.f_setClassVar(dc7.__o_data['dom__jqo_html'], $s_var_name, $o_var_value);
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_checkInit = function($jqo_dom, $s_id)
		{
		///h :
		var $b_init = null;		///h :

		///h :
		$b_init = true;
	
		///h :
		if(dc7__dom.f_getVar($jqo_dom, $s_id) === null)
			{
			///h :
			dc7__dom.f_setVar($jqo_dom, $s_id, true);

			///h :
			$b_init = false;
			}

		///h :
		return($b_init);
		}
		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_getID = function($jqo_dom)
		{
		///h :
		var $s_id = null;	///h : 

		///h :
		$s_id = $jqo_dom[0].id;

		///h : set id if necessary
		if($s_id === '')
			{
			$s_id = dc7__dom.f_setID($jqo_dom);
			}

		///h :
		return($s_id);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_setID = function($jqo_dom, $s_id)
		{
		///h :
		$s_id = (($s_id === undefined) ? ('uid__' + (dc7__dom.__o_data['s_domtimestamp'] + '__') + ('0000' + (++dc7__dom.__o_data['i_domindex'])).substr(-4)) : $s_id);

		///h :
		$jqo_dom[0].id = $s_id;
 
		///h :
		return($s_id);
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_isValid= function($jqo_dom)
		{
		///h :
		var $b_valid = null;	///h :
		
		///h :
		$b_valid = true;
		
		///h :
		if($jqo_dom === null)
			{
			///h :
			$b_valid = false;
			}
		///h :
		else if($jqo_dom === undefined)
			{
			///h :
			$b_valid = false;
			}
		///h :
		else if($jqo_dom.length < 1)
			{
			///h :
			$b_valid = false;
			}

		///h :
		return($b_valid);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_isVisible = function($jqo_dom)
		{
		///h : properties
		var $b_visible = false;				///h: stores data

		///h : check
		$b_visible = true;
		if($jqo_dom.css('display') === 'none')
			{
			$b_visible = false;
			}
		else if($jqo_dom.css('visibility') === 'hidden')
			{
			$b_visible = false;
			}
			
		///h : return
		return($b_visible);
		}
		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_isInViewport = function($jqo_dom)
		{
		///h :
		var $b_in_viewport = false;		///h :

		///h :
		if($jqo_dom.parent().css('display') !== 'none')
			{
			///h :
			$b_in_viewport = $jqo_dom.is(':in-viewport');	
			}

		///h :
		return($b_in_viewport);
		}	


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_removeClasses = function($jqo_dom, $s_class_names)
		{
		if($jqo_dom.length < 1)
			{
			return;
			}
		
		$a_class_names = $s_class_names.split(' ');
		$i_class_names = $a_class_names.length;
		for($i_loop = 0; $i_loop < $i_class_names; $i_loop++)
			{
			$s_class_name = $a_class_names[$i_loop];
			
			///h : normal removal
			if($s_class_name.indexOf('*') === -1)
				{
				$jqo_dom.removeClass($s_class_names);
				}
			///h : wildcard removal
			else
				{
				regx = new RegExp('\\b' + $s_class_name + '.*?\\b', 'g');
				$jqo_dom[0].className = $jqo_dom[0].className.replace(regx, '');
				}
			}
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_setClass = function($jqo_dom, $s_class_name, $b_class_add)
		{
		$b_class_add = (($b_class_add === undefined) ? !($jqo_dom.hasClass($s_class_name) === true) : $b_class_add);
		$s_function_name = (($b_class_add === true) ? 'addClass' : 'removeClass');
		
		///h : add or remove
		$jqo_dom[$s_function_name]($s_class_name);
		}

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_setClassVar = function($jqo_dom, $s_var_name, $s_var_value)
		{
		///h : remove old class var
		dc7__dom.f_removeClasses($jqo_dom, ($s_var_name + '__*'));

		///h : set new
		$jqo_dom.addClass($s_var_name + '__' + $s_var_value);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_getClassVar = function($jqo_dom, $s_var_name)
		{
		var $s_var_value = null;
			
		$s_class_names = $jqo_dom.attr('class');
		$a_class_names = $s_class_names.split(' ');
		$i_class_names = $a_class_names.length;
		for($i_loop = 0; $i_loop < $i_class_names; $i_loop++)
			{
			$s_class_name = $a_class_names[$i_loop];
			if($s_class_name.indexOf($s_var_name) === 0)
				{
				$s_var_value = ($s_class_name.substr($s_var_name.length + 2));
				break;
				}
			}
		
		///h : return
		return($s_var_value);
		}
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__dom.f_repaint = function($jqo_dom)
		{
		///h : properties
		var $s_display = null;	///h :
		var $s_height = null;	///h :
		
		///h :
		$s_display = $jqo_dom[0].style.display;
		$jqo_dom[0].style.display = 'none';
		$s_height = $jqo_dom[0].offsetHeight;
		$jqo_dom[0].style.display = $s_display;
		}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : direct call
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

///h : init system
jQuery(document).bind('ready', {}, function(){dc7__dom.f_initSystem();});


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : description
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
